import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { message } from "antd";

import Candidate from "redux/models/candidate";
import { setUploadCandidate } from "redux/slices/candidateSlice";

export const useUploadModal = (uploadedCandidate, onBeforeNavigate) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [modalState, setModalState] = useState({
    open: false,
    loading: false,
    errors: null,
    statusChangeWarnings: {},
    isOperationConfirmed: false,
  });

  const handleOpen = () => {
    setModalState((prev) => ({ ...prev, open: true, loading: false }));
  };

  const handleConfirm = async () => {
    setModalState((prev) => ({ ...prev, loading: true }));
    try {
      const res = await Candidate.uploadCSV({
        data: uploadedCandidate,
        isOperationConfirmed: modalState.isOperationConfirmed,
      });

      const hasStatusChangeWarnings = Object.values(res?.errors ?? {}).some(
        (emails) => !!emails?.length,
      );

      if (!hasStatusChangeWarnings) {
        setModalState((prev) => ({ ...prev, open: false, loading: false }));
        onBeforeNavigate?.();
        dispatch(setUploadCandidate([]));
        history.goBack();
        message.success(
          "Candidates upload request successfully received! Check your email shortly",
        );
      } else {
        setModalState((prev) => ({
          ...prev,
          statusChangeWarnings: res.errors,
          loading: false,
          isOperationConfirmed: true,
        }));
      }
    } catch (err) {
      const {
        error: { data },
      } = err;
      setModalState((prev) => ({
        ...prev,
        loading: false,
        errors: data.errors,
        statusChangeWarnings: {},
      }));
    }
  };

  const handleCancel = () => {
    setModalState((prev) => ({
      ...prev,
      open: false,
      statusChangeWarnings: {},
      isOperationConfirmed: false,
      errors: null,
    }));
  };

  return { modalState, handleOpen, handleConfirm, handleCancel };
};
